import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_CART_WAS_UPDATED, STR_FEMALE, STR_IMAGE, STR_MALE } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdAdd, MdAddShoppingCart, MdAttachFile, MdDeleteOutline, MdLocationPin, MdPlusOne } from "react-icons/md";
import { GiTalk } from "react-icons/gi";
import { IoChatbubble, IoChatbubblesOutline } from "react-icons/io5";
import { BiMinus, BiSolidCartDownload } from "react-icons/bi";

export default function View({ data, index }) {
	const appContext = useContext(AppContext);

	/* Place states here */

	

	useEffect(() => {
		//..
	}, [data])

	return (
		<div 
			className="d-flex" 
			
			style={{
				marginTop: "10px",
				marginBottom: "10px",
				borderBottom: "2px solid var(--surfaceColor)",
				borderRadius: "20px",
				overflow: "hidden",
				height: "auto"
			}}
		>
			<div 
				className=""
				style={{
					width: "100px",
					height: "100%",
					flexShrink: "0",
					padding: "5px"
				}}
			>
				<img
					src={CDN_URL+data.photo1}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "cover",
					}}
				/>
			</div>

			<div
				style={{
					padding: "10px",
					flexGrow: "1",
					minWidth: "0",
					position: "relative",
				}}
			>
				<h6
					className="font-semi-bold text-secondary"
					style={{
						fontSize: "16px"
					}}
				>
					{data.title}
				</h6>

			
				<h6
					className="text-end mTwoLineText"
					style={{
						fontSize: "18px"
					}}
				>
					<span 
						className="font-semi-bold d-block" 
						style={{ 
							fontSize: "14px", 
							textTransform: "uppercase" 
						}}
					>
						<span style={{ fontSize: "12px" }} className="badge bg-dark">{data.unit}</span> &nbsp; X &nbsp; {data.itemQuantity} 
					</span>
					<span style={{ fontSize: "18px" }}>TZS</span> <span className="font-bold">{formatMoney(Number(data.unitPrice) * Number(data.itemQuantity))}</span>
					
				</h6>

				{
					(Number(index) > -1) ?
					<div className="text-end">
						<MdDeleteOutline 
							size={24}
							className="text-danger"
							onClick={() => {
								appContext.removeItemFromCart({itemId: data.id})
							}}
						/>
					</div>
					:""
				}

			</div>
		</div>
	)
}
